module.exports = __webpack_public_path__ + "img/فولدر تحریر.71660c54.jpg";